jQuery(function($) {
  var included1Variants = [];
  var included2Variants = [];
  try {
    var $included1Json = $('#included-1-product-variants');
    if ($included1Json.length) {
      included1Variants = JSON.parse($included1Json.text());
    }
  } catch (e) {
    included1Variants = [];
  }
  try {
    var $included2Json = $('#included-2-product-variants');
    if ($included2Json.length) {
      included2Variants = JSON.parse($included2Json.text());
    }
  } catch (e) {
    included2Variants = [];
  }

  function filterIncludedBySwatch($btn) {
    var swatchValue = $btn.attr('value') || $btn.val() || '';

    $('.included_items > div').each(function() {
      var $group = $(this);
      var $items = $group.children('.included_item');
      if (!$items.length) return;

      var $matches = $items.filter(function() {
        var itemValue = String($(this).attr('value') || '').trim().toLowerCase();
        var swatch = String(swatchValue).trim().toLowerCase();
        return itemValue === swatch || itemValue.split(' / ')[0] === swatch;
      });

      if (!$matches.length) return;

      $items.hide();
      $matches.show();
    });
  }

  function getSelectedSwatchValues($scope) {
    if (!$scope || !$scope.length) $scope = $('.product_toggle_button.selected');
    if (!$scope.length) $scope = $(document);

    return $scope.find('.swatch_button.selected').map(function() {
      return $(this).attr('value') || $(this).val() || '';
    }).get().filter(Boolean);
  }

  function findMatchingVariant(selectedValues, variants) {
    if (!selectedValues.length || !variants || !variants.length) return null;

    for (var i = 0; i < variants.length; i++) {
      var title = String(variants[i].title || '').toLowerCase();
      var allMatch = selectedValues.every(function(val) {
        return title.indexOf(String(val).toLowerCase()) !== -1;
      });
      if (allMatch) return variants[i];
    }
    return null;
  }

  function writeCheckoutLines($links, lines) {
    if (!lines) return;
    $links.each(function() {
      var href = $(this).attr('href') || '';
      var pattern = lines.indexOf(',') === -1
        ? /\/cart\/\d+:\d+/
        : /\/cart\/\d+:\d+(,\d+:\d+)?/;
      $(this).attr('href', href.replace(pattern, '/cart/' + lines));
    });
  }

  function updateTaylorPreorder() {
    $('.choose_second_product').each(function() {
      var $wrapper = $(this);
      var $h3 = $wrapper.find('h3');
      var $btn = $wrapper.find('.swatch_button.selected, .image-swatch.selected').first();
      var $msg = $h3.find('pre-order-message');
      var isOos = $btn.length && parseInt($btn.attr('data-inventory'), 10) <= 0;

      if (isOos) {
        var ship = $.trim($btn.attr('data-ship-date') || '');
        var name = $.trim($btn.attr('value') || $btn.val() || 'Taylor').toLowerCase().replace(/\b[a-z]/g, function(letter) {
          return letter.toUpperCase();
        });
        var text = ship ? (name + ' Pre-order: Est. to Ship ' + ship) : (name + ' Pre-order');
        if (!$msg.length) {
          $msg = $('<pre-order-message></pre-order-message>');
          var $og = $h3.find('pre-order-message-og');
          if ($og.length) {
            $og.after($('<br>'), $msg);
          } else {
            $h3.find('span').after($('<br>'), $msg);
          }
        }
        $msg.text(text);
      } else {
        $msg.prev('br').remove();
        $msg.remove();
      }
    });
  }

  function updateCheckoutVariant() {
    var $lastCard = $('.product_toggle_buttons .product_toggle_button:last-child');
    var match1 = included1Variants[0] || null;
    var match2 = findMatchingVariant(
      getSelectedSwatchValues($lastCard.find('.choose_second_product')),
      included2Variants
    );
    if (match1 && match2) {
      writeCheckoutLines($('.checkout_link'), match1.id + ':1,' + match2.id + ':1');
    }
  }

  $(document).on('click', '.swatch_button', function() {
    var $btn = $(this);
    $btn.siblings('.swatch_button').removeClass('selected');
    $btn.addClass('selected');
    filterIncludedBySwatch($btn);
    updateCheckoutVariant();
    updateTaylorPreorder();
  });

  $('.swatch_button.selected').each(function() {
    filterIncludedBySwatch($(this));
  });
  updateCheckoutVariant();
  updateTaylorPreorder();
});
